module.exports = __webpack_public_path__ + "img/ashp.3375663d.png";